export default __webpack_public_path__ + "static/media/prototype.af30ade3.svg";